import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldlayoutsSchemesEntityRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-fieldlayouts-schemes-entity',
	path: '/secure/admin/ViewEditFieldLayoutSchemeEntity([!%]?[\\w]*).jspa',
};
